// Client-side mirror of the backend's academic-year.js fallback logic — used
// only when the API response doesn't already include an academic_year value.
// Moroccan academic year starts in September: Sep-Dec -> current calendar
// year, Jan-Aug -> previous calendar year.
export function getDefaultAcademicYear(now = new Date()) {
  const month = now.getMonth() + 1; // 1-12
  return month >= 9 ? now.getFullYear() : now.getFullYear() - 1;
}
